import React, { PropsWithChildren } from 'react';
import { Alert } from '@mui/material';
import useAuth from 'hooks/useAuth';

type RoleGuardProps = PropsWithChildren<{
  roles: string[];
  guardType?: 'element' | 'route';
}>;

export function RoleGuard({ roles, guardType = 'element', children }: RoleGuardProps) {
  const { user } = useAuth();
  const userRoles = (user?.roles ?? []).map((role) => role.toLowerCase());
  const hasRole = roles.some((role) => userRoles.includes(role.toLowerCase()));

  if (!hasRole) {
    return guardType === 'route' ? <Alert severity="warning">Nincs jogosultságod az oldal megtekintéséhez.</Alert> : null;
  }

  return <>{children}</>;
}
